import { render, staticRenderFns } from "./ResultManagerForm.vue?vue&type=template&id=21c74d3f"
import script from "./ResultManagerForm.vue?vue&type=script&lang=js"
export * from "./ResultManagerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports